import api from "./api";
import { NOTIFICATION_API_ENDPOINTS } from "../constants/notification.constant";

const BASE_URL = process.env.REACT_APP_PUSH_API_BASE || "/push";

export const getDevices = async (params) => {
  return api.get(`${BASE_URL}${NOTIFICATION_API_ENDPOINTS.GET_DEVICES}`, {
    params,
  });
};

export const toggleDevice = async (deviceId, isActive) => {
  const endpoint = NOTIFICATION_API_ENDPOINTS.TOGGLE_DEVICE.replace(
    ":id",
    deviceId
  );
  // Note: API uses PATCH to /admin-devices/:id/toggle, not just toggle active status
  return api.patch(`${BASE_URL}${endpoint}`, { isActive });
};

export const exportDevices = async (filters) => {
  // Export functionality - this might need to be implemented server-side
  // For now, we'll fetch all data and export client-side
  const allDevices = [];
  let cursor = null;
  let hasMore = true;

  while (hasMore) {
    const response = await api.get(
      `${BASE_URL}${NOTIFICATION_API_ENDPOINTS.GET_DEVICES}`,
      {
        params: { ...filters, cursor, limit: 100 },
      }
    );

    allDevices.push(...response.data.devices);
    cursor = response.data.nextCursor;
    hasMore = response.data.hasMore;
  }

  // Convert to CSV
  const headers = [
    "ID",
    "User",
    "Platform",
    "Model",
    "OS Version",
    "App Version",
    "Active",
    "Created",
    "Updated",
  ];
  const rows = allDevices.map((device) => [
    device.id,
    device.userId?.name || device.userId,
    device.platform,
    device.model || "",
    device.osVersion || "",
    device.appVersion || "",
    device.isActive ? "Yes" : "No",
    new Date(device.createdAt).toISOString(),
    new Date(device.updatedAt).toISOString(),
  ]);

  const csv = [headers, ...rows].map((row) => row.join(",")).join("\n");
  return { data: csv };
};

// Helper function to format device info
export const formatDeviceInfo = (device) => {
  const info = [];

  if (device.osVersion) info.push(`OS: ${device.osVersion}`);
  if (device.appVersion) info.push(`App: v${device.appVersion}`);
  if (device.model) info.push(`Model: ${device.model}`);

  return info.join(" • ");
};

// Helper function to get platform icon
export const getPlatformIcon = (platform) => {
  if (!platform) return "📱"; // Default icon if platform is undefined

  const icons = {
    IOS: "🍎",
    ANDROID: "🤖",
    WEB: "🌐",
  };
  return icons[platform] || "📱";
};

export const updateDevicePrefs = async (deviceId, prefs) => {
  const endpoint = `${NOTIFICATION_API_ENDPOINTS.GET_DEVICES}/${deviceId}/prefs`; // Using the new endpoint
  return api.put(`${BASE_URL}${endpoint}`, { prefs });
};
